// src/pages/InvalidRequest404.tsx
import React from 'react'
import { Helmet } from 'react-helmet-async';
import { Banner, Div } from '../styles/_app.style'

const InvalidRequest404 = () => {
  return (
    <>
    <Helmet><title>404 - tute</title></Helmet>
    <Div
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Banner style={{ fontWeight: 'bold', fontSize: 30 }}>
        <span>404</span>
        <span>The resource you're looking for doesn't exist</span>
      </Banner>
    </Div>
    </>
  )
}

export default InvalidRequest404
